"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpUrls = void 0;
const helpUrls = exports.helpUrls = {
  helpBaseUrl: 'https://kb.kentik.com',
  admin: {
    deviceSettings: 'v4/Cb01.htm#Cb01-Device_Settings_Dialog',
    configuringFlows: 'v4/Cb35.htm#Cb35-Device_Flow_Settings',
    configuringSNMP: 'v4/Cb35.htm#Cb35-Device_SNMP_Settings',
    configuringBGP: 'v4/Cb35.htm#Cb35-Device_BGP_Settings',
    configureST: 'v0/Ab12.htm#Ab12-Streaming_Telemetry_Data_in_KDE',
    queriesUsingTags: 'v0/Eb02.htm#Eb02-Queries_Using_Tags',
    tagFieldDefinitions: 'v4/Cb04.htm#Cb04-Tag_Field_Definitions',
    configuringKprobe: 'v0/Bd03.htm#Bd03-kprobe_Command_Line'
  },
  dashboards: {},
  dataExplorer: {},
  queryEditor: {},
  alerts: {},
  analytics: {}
};